const BLOCKING_ACTION_BLOCK = 'block'
const BLOCKING_ACTION_REDIRECT = 'redirect'
const BLOCKING_ACTION_LIMIT_COOKIES = 'limit_cookies'

const BLOCKING_ACTION_OPTIONS = [
  { value: BLOCKING_ACTION_BLOCK, label: 'Bloquear acesso' },
  { value: BLOCKING_ACTION_REDIRECT, label: 'Redirecionar URL' },
  { value: BLOCKING_ACTION_LIMIT_COOKIES, label: 'Limitar Cookies' },
]

const TEXT_FIELDS = {
  TITLE: 'ageGate.title',
  DESCRIPTION: 'ageGate.description',
  ACCEPT_BUTTON: 'ageGate.acceptButtonText',
  REJECT_BUTTON: 'ageGate.rejectButtonText',
  BLOCK_TITLE: 'ageGate.blockTitle',
  BLOCK_DESCRIPTION: 'ageGate.blockDescription',
}

const ORDERED_TEXT_FIELDS = [
  TEXT_FIELDS.TITLE,
  TEXT_FIELDS.DESCRIPTION,
  TEXT_FIELDS.ACCEPT_BUTTON,
  TEXT_FIELDS.REJECT_BUTTON,
]

const ORDERED_TEXT_FIELDS_BLOCKING = [
  TEXT_FIELDS.BLOCK_TITLE,
  TEXT_FIELDS.BLOCK_DESCRIPTION,
]

const TEXT_FIELD_CONFIG = {
  [TEXT_FIELDS.TITLE]: { label: 'Título', multiline: false },
  [TEXT_FIELDS.DESCRIPTION]: { label: 'Descrição', multiline: true },
  [TEXT_FIELDS.ACCEPT_BUTTON]: { label: 'Botão Aceitar', multiline: false },
  [TEXT_FIELDS.REJECT_BUTTON]: { label: 'Botão Rejeitar', multiline: false },
}

const TEXT_FIELD_CONFIG_BLOCKING = {
  [TEXT_FIELDS.BLOCK_TITLE]: {
    label: 'Título da tela de bloqueio',
    multiline: false,
  },
  [TEXT_FIELDS.BLOCK_DESCRIPTION]: {
    label: 'Descrição da tela de bloqueio',
    multiline: true,
  },
}

const TEXT_FIELD_PLACEHOLDERS = {
  'pt-BR': {
    [TEXT_FIELDS.TITLE]: 'Verificação de idade',
    [TEXT_FIELDS.DESCRIPTION]:
      'Este site contém conteúdo restrito para maiores de idade. Por favor, confirme sua idade para continuar.',
    [TEXT_FIELDS.ACCEPT_BUTTON]: 'Sou maior de idade',
    [TEXT_FIELDS.REJECT_BUTTON]: 'Sou menor de idade',
  },
  'en-US': {
    [TEXT_FIELDS.TITLE]: 'Age verification',
    [TEXT_FIELDS.DESCRIPTION]:
      'This site contains content restricted to adults. Please confirm your age to continue.',
    [TEXT_FIELDS.ACCEPT_BUTTON]: 'I am of legal age',
    [TEXT_FIELDS.REJECT_BUTTON]: 'I am underage',
  },
  'es-ES': {
    [TEXT_FIELDS.TITLE]: 'Verificación de edad',
    [TEXT_FIELDS.DESCRIPTION]:
      'Este sitio contiene contenido restringido para mayores de edad. Por favor, confirme su edad para continuar.',
    [TEXT_FIELDS.ACCEPT_BUTTON]: 'Soy mayor de edad',
    [TEXT_FIELDS.REJECT_BUTTON]: 'Soy menor de edad',
  },
}

const TEXT_FIELD_BLOCKING_PLACEHOLDERS = {
  'pt-BR': {
    [TEXT_FIELDS.BLOCK_TITLE]: 'Acesso restrito',
    [TEXT_FIELDS.BLOCK_DESCRIPTION]:
      'Você não tem idade suficiente para acessar este conteúdo.',
  },
  'en-US': {
    [TEXT_FIELDS.BLOCK_TITLE]: 'Restricted access',
    [TEXT_FIELDS.BLOCK_DESCRIPTION]:
      'You are not old enough to access this content.',
  },
  'es-ES': {
    [TEXT_FIELDS.BLOCK_TITLE]: 'Acceso restringido',
    [TEXT_FIELDS.BLOCK_DESCRIPTION]:
      'No tiene la edad suficiente para acceder a este contenido.',
  },
}

const ageGateTextOverride = {
  BLOCKING_ACTION_BLOCK,
  BLOCKING_ACTION_REDIRECT,
  BLOCKING_ACTION_LIMIT_COOKIES,
  BLOCKING_ACTION_OPTIONS,
  TEXT_FIELDS,
  ORDERED_TEXT_FIELDS,
  ORDERED_TEXT_FIELDS_BLOCKING,
  TEXT_FIELD_CONFIG,
  TEXT_FIELD_CONFIG_BLOCKING,
  TEXT_FIELD_PLACEHOLDERS,
  TEXT_FIELD_BLOCKING_PLACEHOLDERS,
}

export default ageGateTextOverride
